import { NgIf } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DynamicFormControlCustomEvent } from '@ng-dynamic-forms/core';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { EVENT_TYPE_PRINT_PDF_INFOCLIENT, NachrichtReferentModel } from './nachricht-referent.model';

// NOTE:
// The base class CustomDynamicFormControlComponent already includes all inputs and outputs needed, as well
// as additional convenience methods onDisabledChange() and onValueChange, for when model.disabled and model.value change,
// respectively.

export type Timestamp = {
  date: string;
  time: string;
};

@Component({
  selector:    'gsm-nachricht-referent',
  templateUrl: 'nachricht-referent.component.html',
  styleUrls:   ['nachricht-referent.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatIconButton,
    MatTooltip,
    MatIcon
  ]
})
export class NachrichtReferentComponent extends CustomDynamicFormControlComponent<NachrichtReferentModel> implements OnInit {
  timestamps: Timestamp[] = [];
  @Output() customEvent = new EventEmitter<DynamicFormControlCustomEvent>();

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange(): void {
    super.onModelChange();
    if (this.model?.additional?.messageHistory) {
      this.timestamps = this.model.additional.messageHistory
        .map(element => ({
          date: element.slice(0, 10),
          time: element.slice(11, 16)
        }))
        .reverse();
    }
  }

  goToInfoclient() {
    this.customEvent.emit({
      customEvent:     new CustomEvent(EVENT_TYPE_PRINT_PDF_INFOCLIENT, {}),
      customEventType: EVENT_TYPE_PRINT_PDF_INFOCLIENT
    });
  }
}
